var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 0L11.1962 6.75H0.803848L6 0Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }